import React, { useEffect, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MIND_PATTERNS_DATA_AREAS } from '../../../../core/constants';
import { getMindPatternsDataById, mindPatternsDataActions } from '../../../../core/mind-patterns';
import iconMPbrain from '../../../../assets/img/icon-mp-brain.svg';

export const MindPatternsHome = ({ user }) => {
  const dispatch = useDispatch();
  const mindPatternsAreas = useSelector(state => { return getMindPatternsDataById(state, MIND_PATTERNS_DATA_AREAS)});

  useEffect(() => {
    dispatch(mindPatternsDataActions.loadMindPatternsData(MIND_PATTERNS_DATA_AREAS));
  }, [dispatch])

  const getDataArea = useMemo(() => (code) => {
    if (!mindPatternsAreas?.items?.size) return null;

    const area = mindPatternsAreas.items.find(mpArea => { return mpArea.code.toLowerCase() === code.toLowerCase() });
    return area;
  }, [mindPatternsAreas]);

  const attentionTypes = ['Focused attention', 'Sorting attention', 'Open attention']
  const mind_pattern_data = user?.mind_pattern?.split("").map((mp, k) => {
    const area = getDataArea(mp);

    if (!area) return null;

    return (
      <div key={`${k}_${mp}`}>
        <>
          <div className={`border w-100 mb-3 rounded d-flex p-3 mind-pattern border-${area.name.toLowerCase()}`} >
            <i className='mr-2'><img src={area.icon} alt={area.name} width="44" height="44" /></i>
            <div>
              <p className='h4 mb-1'>{area.name}</p>
              <p className='text-muted h5 font-weight-medium mb-0'> {attentionTypes[k]} </p>
            </div>
          </div>
          <div className='px-3'>
            {k === 0 && 
            <p className='text-muted'><strong> Focused attention -</strong> when you concentrate to accomplish tasks in a linear, detailed way.</p>
            }
            {k === 1 &&
            <p className='text-muted'><strong> Sorting attention -</strong> when you seek to make sense of things, digest experiences or process strong emotions.</p>
            }
            {k === 2 &&
            <p className='text-muted'><strong> Open attention -</strong> when you engage in more creative, non-linear and intuitive thinking.</p>
            }
          </div>
        </>
      </div>
    );
  })

  return (
    <div className="p-3">

      {user.mind_pattern &&
        (<>
          {mind_pattern_data && <div className="mind-patterns-content grid-3">{mind_pattern_data}</div>}
        </>)
      }

      {user.assessment_access === 2 && !user.talents ? null :
        (
          <>
            {user.mind_pattern ? '' : (
              <>
                <div className='text-center py-5'>
                  <img src={iconMPbrain} width="78" height="78" alt='Mind Pattern' />
                  <p className="my-4 mt-md-2">Start your <strong>Mind Pattern</strong> assessment to see it come to life!</p>
                  <Link to='/mind-patterns' className="btn btn-sm btn-outline-green-light">
                    <i className="mr-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px' }}>
                        <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z" />
                      </svg>
                    </i>Let’s start!
                  </Link>
                </div>
              </>
            )
            }
          </>
        )
      }
    </div>
  )
}
const mapStateToProps = (state) => {
  const { user } = state;
  return {
    user
  };
};

const mapDispatchToProps = {
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MindPatternsHome);
